const PlayButtonTypes = {
    "default": "default",
    "big": "big"
};
var play_button = Object.freeze(PlayButtonTypes);

export { play_button as default };
//# sourceMappingURL=play_button.js.map
